module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/campaign/campaign.html
// module id = 688
// module chunks = 0